import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text", "icon", "confirmationIcon"];
  static values = {
    text: String,
    initialText: String,
    confirmation: String,
  };

  async copy(event) {
    if (!("clipboard" in navigator)) return;

    try {
      await navigator.clipboard.writeText(this.textValue.trim());
    } catch (e) {
      console.error("Couldn't copy", e);
      return;
    }

    this[this.getTextTarget].innerText = this.confirmationValue;

    if (this.hasIconTarget) this.iconTarget.classList.add("d-none");
    if (this.hasConfirmationIconTarget)
      this.confirmationIconTarget.classList.remove("d-none");

    window.dispatchEvent(
      new CustomEvent("button-copy-reset", {
        detail: { element: this.element },
      }),
    );

    setTimeout(() => this.reset(), 3000);
  }

  get getTextTarget() {
    return this.hasTextTarget ? "textTarget" : "element";
  }

  reset(event) {
    if (event?.detail && event?.detail?.element === this.element) return;

    this[this.getTextTarget].innerText = this.initialTextValue;
    if (this.hasIconTarget) this.iconTarget.classList.remove("d-none");
    if (this.hasConfirmationIconTarget)
      this.confirmationIconTarget.classList.add("d-none");
  }
}
